import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { AlertTriangle, Info } from "lucide-react";

const SEVERITY_COLORS = {
  high: "bg-red-50 border-red-200 text-red-700",
  medium: "bg-amber-50 border-amber-200 text-amber-700",
  low: "bg-yellow-50 border-yellow-200 text-yellow-700",
};

const SEVERITY_BADGE = {
  high: "bg-red-100 text-red-700 border-red-200",
  medium: "bg-amber-100 text-amber-700 border-amber-200",
  low: "bg-yellow-100 text-yellow-700 border-yellow-200",
};

export default function EVETCoPilotPanel({ contradictions = [] }) {
  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-100 bg-gradient-to-r from-orange-50 to-white">
        <AlertTriangle className="w-4 h-4 text-orange-500" />
        <h3 className="text-sm font-semibold text-slate-700">eVET Co-Pilot</h3>
        {contradictions.length > 0 && (
          <Badge variant="secondary" className="ml-auto text-[10px]">
            {contradictions.length} flags
          </Badge>
        )}
      </div>
      <ScrollArea className="h-48">
        {contradictions.length === 0 && (
          <div className="flex flex-col items-center justify-center h-32 text-slate-400">
            <Info className="w-6 h-6 mb-1 opacity-50" />
            <p className="text-xs">No contradictions detected</p>
          </div>
        )}
        <div className="p-3 space-y-2">
          {contradictions.map((item, i) => (
            <div
              key={i}
              className={`p-3 rounded-lg border ${SEVERITY_COLORS[item.severity] || SEVERITY_COLORS.low}`}
            >
              <div className="flex items-start justify-between mb-2">
                <Badge
                  variant="outline"
                  className={`text-[10px] ${SEVERITY_BADGE[item.severity] || SEVERITY_BADGE.low}`}
                >
                  {item.severity}
                </Badge>
              </div>
              <div className="space-y-1.5 text-sm">
                <p><span className="font-medium text-slate-600">A:</span> {item.statement_a}</p>
                <p><span className="font-medium text-slate-600">B:</span> {item.statement_b}</p>
              </div>
              {item.explanation && (
                <p className="text-xs text-slate-500 mt-2 italic">{item.explanation}</p>
              )}
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}
